import { Values } from '../../../../../types/Survey/Analysis/Calculation'
import { ResultPropsMitarbeiter } from '../../../../../types/Survey/Analysis/FactorValues'

const getMitarbeiter = (values: Values): ResultPropsMitarbeiter => {
  return {
    amount: values.mitarbeiter,
  }
}

export default getMitarbeiter
